import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const List = styled.li`
  display: ${props => (props.inline ? 'inline-block' : 'block')};
  margin: ${props => (props.inline ? '2px .5rem' : '.5rem 0')};
`;

let LI = ({ children, ...otherProps }) => (
  <List {...otherProps}>{children}</List>
);

LI.propTypes = {
  children: PropTypes.node.isRequired
};

export default LI;



// WEBPACK FOOTER //
// ./src/components/LI.js